/**
 * OAuth return-to binding (RAISE-19789).
 *
 * The git-auth OAuth `state` is an opaque server nonce; we bind the page that
 * started the flow to that exact state in sessionStorage so the callback can
 * return there. Only same-origin relative paths are ever stored or returned
 * (isSafeRedirect) — never absolute URLs (open redirect).
 */
import { isSafeRedirect } from "@/lib/safeRedirect";

const PREFIX = "raise.oauth.return_to:";

export function rememberReturnTo(state: string, path: string): void {
  if (!state || !isSafeRedirect(path)) return;
  try {
    sessionStorage.setItem(PREFIX + state, path);
  } catch {
    // storage unavailable — callback falls back to its default
  }
}

export function consumeReturnTo(state: string): string | null {
  try {
    const key = PREFIX + state;
    const value = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    return isSafeRedirect(value) ? value : null;
  } catch {
    return null;
  }
}
